import {validators} from 'vue-form-generator';
import {poBoxNotInAddress, ampersandNotInAddress, invalidCountry, invalidState} from './customValidations';
import {setCustomValidationProperties} from '../customValidationHelpers';
import {googleCountriesToSFDCCountries, countriesToStates, countriesWithoutStates, validCountries} from './settings';
import {getCityFromRawPlace, setState} from './helpers';
import {titleCase} from '../../../utils';


export const address1 = {
    type: 'googleAddress',
    inputType: 'text',
    label: '',
    id: 'address-line-1',
    model: 'address1',
    placeholder: '',
    required: true,
    disabled: false,
    styleClasses: "col xs-12",
    validator: [
        validators.string
    ],
    onPlaceChanged: function(value, place, rawPlace, model, schema) {
        model.address1 = place.street_number ? place.street_number + " " + place.route : "";
        model.city = place.locality || getCityFromRawPlace(rawPlace) || "";
        model.zip = place.postal_code || "";
        model.country = googleCountriesToSFDCCountries[place.country] || place.country || "";
        model.state = setState(model.country, place);
    },
}

export const address2 = {
    type: 'input',
    inputType: 'text',
    label: '',
    id: 'address-line-2',
    model: 'address2',
    required: false,
    disabled: false,
    styleClasses: "col xs-12",
    validator: [
        validators.string,
    ],
}

export const city = {
    type: 'googleAddress',
    inputType: 'text',
    label: '',
    id: 'city',
    model: 'city',
    placeholder: '',
    required: true,
    disabled: false,
    styleClasses: "col xs-12 md-3",
    validator: [validators.string],
    onPlaceChanged: function(value, place, rawPlace, model, schema) {
        model.city = place.locality || getCityFromRawPlace(rawPlace) || "";
        model.country = googleCountriesToSFDCCountries[place.country] || place.country || "";
        model.state = setState(model.country, place);
    },
}

export const state = {
    type: 'dropdown',
    label: '',
    id: 'state',
    model: 'state',
    values: function(model) {
        let country = model.country ? model.country.toLowerCase() : "";
        if (country && !countriesWithoutStates.includes(country)) {
            return countriesToStates[country].map((state) => {
                let stateDisplayed = titleCase(state);
                return {name: stateDisplayed, value: stateDisplayed}
            });
        };
        return [];
    },
    required: function(model) {
        let country = model.country ? model.country.toLowerCase() : "";
        return !countriesWithoutStates.includes(country);
    },
    visible: function(model) {
        let country = model.country ? model.country.toLowerCase() : "";
        return !countriesWithoutStates.includes(country);
    },
    disabled: false,
    styleClasses: "col xs-12 md-3",
    validator: [
        validators.string,
        setCustomValidationProperties(invalidState, "invalidState")
    ],
}

export const zip = {
    type: 'googleAddress',
    inputType: 'text',
    label: '',
    id: 'zip',
    model: 'zip',
    placeholder: '',
    required: true,
    disabled: false,
    styleClasses: "col xs-12 md-3",
    validator: [validators.string],
    onPlaceChanged: function(value, place, rawPlace, model, schema) {
        model.zip = place.postal_code || "";
    }
}

export const country = {
    type: 'dropdown',
    label: '',
    id: 'country',
    model: 'country',
    values: function(model) {
        return validCountries.map((country) => {
            let countryDisplayed = country ? titleCase(country) : "";
            return {name: countryDisplayed, value: countryDisplayed};
        });
    },
    default: "United States",
    required: true,
    disabled: false,
    styleClasses: "col xs-12 md-3",
    validator: [
        validators.string,
        setCustomValidationProperties(invalidCountry, "invalidCountry")
    ],
}
